<template>
    <v-toolbar app color="#FF761C" class="text--white" dark v-if="isAuthenticated">
        <v-toolbar-side-icon class="white--text" @click="toggleDrawer"></v-toolbar-side-icon>
        <v-toolbar-title class="headline text-uppercase">
            <span>Bitacorapp Ronda</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down" v-if="isAuthenticated">
            <v-menu bottom offset-y>
                <v-btn class="white--text" flat slot="activator"><i class="fas fa-user"></i> <div class="mx-3">{{ user.name }}</div> <i class="fas fa-angle-down"></i></v-btn>
                <v-list>
                    <v-list-tile @click="logout">
                        <v-list-tile-title>Cerrar Sesión</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar-items>
    </v-toolbar>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    methods: {
        ...mapActions(['logout']),
        toggleDrawer() {
            this.setDrawer(!this.drawer);
        }
    }
}
</script>
